import { Component, OnInit } from '@angular/core'
import { TransactionsServices } from '../../../@theme/services/transactions.service'
import { TransactionDetails } from '../transaction-model'
import { TransactionStateService } from '../transaction-state.service'

@Component({
    selector: 'gd-trasaction-details',
    templateUrl: './transaction-details.component.html',
    styleUrls: ['./transaction-details.component.scss'],
    standalone: true,
})
export class TransactionDetailsComponent implements OnInit {
  public blotterId: number
  public details: any

  constructor(
    private transactionService: TransactionsServices,
    private transactionStateService: TransactionStateService,
  ) {}

  ngOnInit() {
    if (this.transactionStateService.blotterId) {
      this.transactionService
        .getTransactionDetails({
          blotterId: this.transactionStateService.blotterId,
        })
        .subscribe((response) => {
          this.details = response as TransactionDetails
        })
    }

    //this.transactionService.getTransactionDetails()
  }
}
